module.exports={select:"Seleziona",selected:"Selezionato"};